<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-eye"></i> {{title | translate}}</h4>
  </div>
  <div class="modal-body custom-background">
    <div class="row mb-2" [hidden]="hasUniqueDocument">
      <div class="col-md-2 custom-container-left-padding">
        <label for="enterpriseInput" class="font-weight-bold">{{ "LABEL.DOCUMENTS-TO-REVIEW" | translate }}</label>
      </div>
      <div class="col-md-10 custom-padding-left">
        <select id="enterpriseInput"
                class="form-control custom-combobox"
                [(ngModel)]="document"
                (ngModelChange)="reloadResourceList()">
          <option *ngFor="let document of documents" [ngValue]="document">{{document.subject | translate}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div
        class="{{hasUniqueDocument?'col-md-1':'col-md-2'}} font-weight-bold">{{ "LABEL.ATTACHMENTS" | translate }}</div>
      <div
        class="{{hasUniqueDocument?'col-md-11':'col-md-10'}} font-weight-light custom-container-right-padding custom-div-words">
        <a href="javascript:" *ngFor="let resource of resourceList; let index=index"
           (click)="setUrlDoc(resource)">{{resource.fileName}}; </a>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-md-12" style="height: 500px">
        <div class="custom-height-full mt-2" *ngIf="!reloadingPdf">
          <ng2-pdfjs-viewer #pdfViewer
                            [pdfSrc]="urlStream"
                            [download]="false"
                            [print]="false"
                            [openFile]="false"
                            [showSpinner]="true"
                            [viewBookmark]="false"
                            viewerId="documentVisor">
          </ng2-pdfjs-viewer>
        </div>
      </div>
    </div>
    <div class="col-md-12 mt-2">
      <form [formGroup]="reviewForm">
        <div class="form-row">
          <div class="row col-md-12 offset-sm-2 custom-container-right-padding pl-1">
            <div class="col-md-3 custom-col custom-control custom-checkbox my-1 mr-sm-2 custom-float">
              <input type="checkbox"
                     class="custom-control-input"
                     id="observedCheckbox"
                     formControlName="observed"
                     [checked]="getObservedCheckedBy(document)"
                     (change)="changeObserved($event)">
              <label class="custom-control-label"
                     for="observedCheckbox">{{ "LABEL.OBSERVE-DOCUMENT" | translate }}</label>
            </div>
            <div class="col-md-3 custom-col custom-control custom-checkbox my-1 mr-sm-2 custom-float">
              <input type="checkbox"
                     class="custom-control-input"
                     id="cancelCheckbox"
                     formControlName="cancelled"
                     [checked]="getCancelledCheckedBy(document)"
                     (change)="changeCancelled($event)">
              <label class="custom-control-label" for="cancelCheckbox">{{ "LABEL.CANCEL-DOCUMENT" | translate }}</label>
            </div>
            <div class="col-md-5 custom-col custom-control custom-checkbox my-1 mr-sm-2 custom-float"
                 *ngIf="hasUniqueDocument && hasUniqueAttach && !cancelChecked  && !observedChecked">
              <input type="checkbox"
                     class="custom-control-input"
                     id="attachCheckbox"
                     formControlName="attach"
                     (change)="changeAttach($event)"
                     [attr.disabled]="closeStamping ? '' : null"
                     [ngbTooltip]="closeStamping ? tipAttach : null">
              <label class="custom-control-label"
                     for="attachCheckbox"
                     [ngbTooltip]="closeStamping ? tipAttach : null">{{ "LABEL.ATTACH-FILE" | translate }}</label>
            </div>
          </div>
        </div>
        <div class="form-row mt-3">
          <div class="col-md-2">
            <label for="commentInput" class="font-weight-bold">{{ "LABEL.COMMENT" | translate }}</label>
          </div>
          <div class="col-md-10">
              <textarea type="text"
                        rows="3"
                        id="commentInput"
                        class="form-control textarea"
                        placeholder="{{ 'MESSAGE.ENTER-A-COMMENT' | translate }}"
                        formControlName="comment"
                        [value]="getCommentBy(document)"
                        (keyup)="keyupComment($event)"
                        [class.is-invalid]="isInvalidControl('comment')">
              </textarea>
            <small *ngIf="isInvalidControl('comment')"
                   class="text-danger">
              {{ "MESSAGE.ITS-NECESSARY-TO-ENTER-COMMENT" | translate }}
            </small>
          </div>
        </div>
        <div class="form-row mt-3" *ngIf="attachSelected">
          <div class="col-md-2">
            <label for="attachment" class="font-weight-bold">{{ "LABEL.ANNEX" | translate }}</label>
          </div>
          <div class="col-md-6">
            <div class="custom-file ml-0">
              <input type="file" class="custom-file-input" accept="application/pdf"
                     id="attachment" (change)="changeStatus($event)">
              <label class="custom-file-label"
                     for="attachment">
                {{reviewForm.get('filename').value ? reviewForm.get('filename').value : 'MESSAGE.SELECT-ANNEX' | translate }}
              </label>
              <small *ngIf="isInvalidControl('file')"
                     class="text-danger">
                {{ "MESSAGE.ITS-NECESSARY-TO-SELECT-ANNEXED-FILE" | translate }}
              </small>
            </div>
          </div>
          <div class="col-md-4">
            <div class="progress form-group mt-2">
              <div class="progress-bar progress-bar-striped bg-success"
                   role="progressbar"
                   [style.width.%]="progressUpdate">
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success " (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}</button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i>{{ "BUTTON.CANCEL" | translate }}</button>
  </div>
</div>

<app-loading *ngIf="loading"></app-loading>
<ng-template #tipAttach>{{ "MESSAGE.ATTACHMENT-ARE-NOT-ALLOWED" | translate }}</ng-template>
